<template>
  <el-row class="warp">
    <el-col :span="6" class="warp-breadcrum">
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item :to="{ path: '/' }">
            <b>首页</b>
          </el-breadcrumb-item> -->
          <el-breadcrumb-item>期刊列表</el-breadcrumb-item>
        </el-breadcrumb>
    </el-col>

    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="刊名：">
            <el-input v-model="searchForm.journalName" placeholder="期刊名称"></el-input>
          </el-form-item>
          <el-form-item label="ISSN:">
            <el-input v-model="searchForm.issn" placeholder="ISSN"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button size="small" type="primary" @click="findResult(null)">查 询</el-button>
          </el-form-item>
          <el-form-item>
              <el-button size="small" type="primary" @click="insert">新 增</el-button>
          </el-form-item>
        </el-form>
    </el-col> 

    <!-- 列表显示 begin-->
    <el-col :span="24" class="tablebar" style="padding-bottom: 0px;">
      <el-table :data="journals" style="width: 100%" stripe resizable="true" v-loading="tableLoading" class="tablebar">
        <!-- 第一行显示数据 -->
        <el-table-column prop="journalName" label="名称" sortable align="center"></el-table-column>
        <el-table-column prop="issn" label="ISSN" sortable align="center"></el-table-column>
        <el-table-column prop="issueTypeName" label="类型" sortable align="center"></el-table-column>
        <el-table-column prop="uploadType" label="上传权限" sortable align="center"></el-table-column>
        <el-table-column prop="auditName" label="审核开关" sortable align="center">
            <template slot-scope="scope">
            <el-tag
              :type="scope.row.audit === true ? 'success' : 'primary'"
              disable-transitions>{{scope.row.auditName}}</el-tag>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="uploadDueName" label="数据上传过期提醒开关" sortable align="center">
            <template slot-scope="scope">
            <el-tag
              :type="scope.row.uploadDue === true ? 'success' : 'primary'"
              disable-transitions>{{scope.row.uploadDueName}}</el-tag>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="checkVolumeIssueName" label="校验卷期开关" sortable align="center">
            <template slot-scope="scope">
            <el-tag
              :type="scope.row.checkVolumeIssue === true ? 'success' : 'primary'"
              disable-transitions>{{scope.row.checkVolumeIssueName}}</el-tag>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 操作按钮 -->
        <el-table-column label="操作" width="200" minWidth="150" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="showEditDialog(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <div slot="empty" class="empty">
          <el-empty description="暂无数据"></el-empty>
        </div>
      </el-table>

      <!--新增对话框界面 begin-->
      <AddJournalDialog ref="addDialog" v-on:signStatusVerdict="listenSignStatus"> </AddJournalDialog>
      <!-- 新增对话框界面 end -->

      <!--编辑对话框界面 begin-->
      <EditJournalDialog ref="editDialog" v-bind:journal="journal" v-on:signStatusVerdict="listenSignStatus"> </EditJournalDialog>
      <!-- 编辑对话框界面 end -->
    </el-col>

    <el-col :span="24" class="foolbar">
      <el-pagination 
        background 
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :page-size="pageSize"
        :page-sizes = pageSizes
        :total="total" 
        hide-on-single-page 
        style="float:right;">
      </el-pagination>
    </el-col>
    
  </el-row>
</template>

<script>
import API_JOURNAL from "../../../api/api_journal";
import AddJournalDialog from "../Journal/AddJournal.vue";
import EditJournalDialog from "../Journal/EditJournal.vue";

export default {
  data() {
    return {
      tableLoading:false,
      searchForm:{
        journalName:"",
        issn:"",
      },
      journal:{},
      journals: [], //期刊列表
      
      //页码
      page: 1,
      //每页数量
      pageSize: 10,
      pageSizes: [10, 20, 50, 100],
      //总数
      total: 0,
      clientHeight: window.innerHeight - 258,
      //在此添加新的数据定义
      pageLoading: false,
    };
  },

  components: {
      AddJournalDialog,
      EditJournalDialog,
  },

  methods: {
    //获取期刊列表
    findJournals(){
      let that = this;
      this.tableLoading = true
      let params = {
          page: that.page,
          pageSize: that.pageSize,
          journalName: that.searchForm.journalName,
          issn: that.searchForm.issn
      };
      API_JOURNAL.getAllJournal(params)
      .then(res=>{
        if(res && res.journal){
          that.journals = Object.values(res.journal);
          that.total = res.total;
        }
      })
      .catch(e=>{
        this.$message({
          showClose:true,
          type:"error",
          message:"请求出现异常",
          duration:2000
        });
      }).finally(()=>{
          this.tableLoading = false
        });;
    },

    insert(){
      this.$refs.addDialog && this.$refs.addDialog.openDialog();
    },

    //通过journalId从后台获取期刊详细信息
    findJournal(_journalId) {
      let that = this;
      let params = {
        journalId: _journalId
      };
      console.log("......findJournal params:" + JSON.stringify(params));
      //发送http请求
      API_JOURNAL.getJournal(params)
        .then(res => {
          if (res) {
            //赋值
            that.journal = res;
            console.log("......findJournal res:" + JSON.stringify(that.journal));
            this.$refs.editDialog && this.$refs.editDialog.openDialog(that.journal); 
          }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    //显示编辑对话框
    showEditDialog: function(index, row) {
      let that = this;
      that.findJournal(row.journalId);
      setTimeout(() => {     
            
      }, 500);
    },
  
    //删除操作
    handleDelete: function(index, row) {
      let that = this;
      that
        .$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          let params = {
            journalId: row.journalId
          };

          console.log(".........journalDelete params:" + JSON.stringify(params));
          //调用post请求，进行删除
          API_JOURNAL.delJournal(params)
            .then(res => {
              console.log(res);
              if (0 === res.errorCode) {
                that.$message({
                  type: "success",
                  message: "删除成功!"
                });

                //更新列表
                that.findJournals();
              } else {
                that.$message({
                  showClose: true,
                  message: res.errorInfo,
                  type: "error"
                });
              }
            })
            .catch(e => {
              that.$message({
                showClose: true,
                type: "error",
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "取消删除"
          });
        });
    },

    listenSignStatus: function(signStatus){
        this.findResult();
    },

    findResult(){
        //点击查询按钮，分页初始化为1
        let _page = 1;
        //重新搜索时进行重置
        this.total = 0;
        //查询前清除查询列表信息
        this.journals = null;
        //进行分页查询
        this.getRows(_page);
    },

    getRows: function(_page) {
        this.page = _page;
        this.findJournals();
    },

    handleSizeChange(val) {
        this.pageSize = val;
        this.findJournals();
    },

    //分页选择处理
    handleCurrentChange: function(val) {
        this.getRows(val);
    },

    //初始化表格高度
    initHeight: function() {
        this.clientHeight = (document.documentElement.clientHeight - 258) + 'px';
    },

  },
  mounted() {
    window.addEventListener('resize', this.initHeight);
    this.initHeight();
    this.findJournals();
  }
};
</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>


// WEBPACK FOOTER //
// src/views/SysMng/Journal/JournalManage.vue